// Official Pasco colour charts (on-screen swatches approximate the printed chart — the physical Pasco chart is authoritative).
export const SEALANT_PRODUCTS = [
  "Hypersil 911",
  "Hypersil 912",
  "Hypersil MATT 912",
  "Pascoflex PU25",
  "Pascoflex Hybrid 25",
];

const HYPERSIL_911 = [
  { name: "Translucent", hex: "#e6ebed" },
  { name: "White", hex: "#f4f3ef" },
  { name: "Chocolate", hex: "#3a291b" },
  { name: "Bronze", hex: "#5c4b2d" },
  { name: "Eucalypt", hex: "#a8b199" },
  { name: "Forest", hex: "#21403a" },
  { name: "Grey", hex: "#a29c92" },
  { name: "Silver", hex: "#8e9195" },
  { name: "Charcoal", hex: "#3b362f" },
  { name: "Volcano", hex: "#46433d" },
  { name: "Black", hex: "#161616" },
];

const HYPERSIL_912 = [
  { name: "Translucent", hex: "#e8edef" },
  { name: "White", hex: "#f5f4f0" },
  { name: "Off White", hex: "#ece5d7" },
  { name: "Light Ivory", hex: "#ece3cb" },
  { name: "Almond Ivory", hex: "#e3d7bd" },
  { name: "Travertine", hex: "#d8ccb4" },
  { name: "Caramel", hex: "#c2ab84" },
  { name: "Teak", hex: "#bd9a63" },
  { name: "Brown", hex: "#574029" },
  { name: "Mushroom", hex: "#b1a598" },
  { name: "Beige Grey", hex: "#b6a993" },
  { name: "Tile Grey", hex: "#cdc8bd" },
  { name: "Chalk", hex: "#dcd8cf" },
  { name: "Light Grey", hex: "#b4b9bb" },
  { name: "Silverstone", hex: "#a5a9ab" },
  { name: "Pewter", hex: "#8d9296" },
  { name: "Bluestone", hex: "#68747f" },
  { name: "Slate Grey", hex: "#576169" },
  { name: "Graphite", hex: "#484c50" },
  { name: "Raven", hex: "#31363a" },
  { name: "Black", hex: "#1b1b1b" },
];

const HYPERSIL_MATT_912 = [
  { name: "Vivid White", hex: "#f6f7f5" },
  { name: "Matt White", hex: "#edefeb" },
  { name: "Walnut", hex: "#58442f" },
  { name: "Ash", hex: "#b6b6b0" },
  { name: "Steel Grey", hex: "#8a9094" },
  { name: "Mid Grey", hex: "#7b8084" },
  { name: "Gunmetal", hex: "#4b5054" },
  { name: "Onyx", hex: "#292c2f" },
];

const PASCOFLEX_PU25 = [
  { name: "White", hex: "#f4f4f0" },
  { name: "Off White", hex: "#e8e2d3" },
  { name: "Sahara Grey", hex: "#b2ab9c" },
  { name: "Beige Grey", hex: "#afa693" },
  { name: "Sandstone", hex: "#c2b194" },
  { name: "Redwood", hex: "#794933" },
  { name: "Grey", hex: "#93979a" },
  { name: "Bluestone", hex: "#5d6c78" },
  { name: "Bronze", hex: "#6c5e49" },
  { name: "Black", hex: "#1a1a1a" },
];

const PASCOFLEX_HYBRID_25 = [
  { name: "Precast White", hex: "#f1eee6" },
  { name: "Mortar", hex: "#e3e1d8" },
  { name: "Sand Beige", hex: "#ddd2ba" },
  { name: "Timber Red", hex: "#9a7157" },
  { name: "Chestnut", hex: "#3e2c20" },
  { name: "Grey Stone", hex: "#b6bbbc" },
  { name: "Steel Blue", hex: "#3f464c" },
  { name: "Anthracite", hex: "#383b3e" },
  { name: "Coal Black", hex: "#161616" },
];

export const PASCO_COLOURS = {
  "Hypersil 911": HYPERSIL_911,
  "Hypersil 912": HYPERSIL_912,
  "Hypersil MATT 912": HYPERSIL_MATT_912,
  "Pascoflex PU25": PASCOFLEX_PU25,
  "Pascoflex Hybrid 25": PASCOFLEX_HYBRID_25,
};

export function findColour(product, name) {
  const list = PASCO_COLOURS[product] || [];
  return list.find((c) => c.name.toLowerCase() === (name || "").toLowerCase());
}

export function colourHex(product, name) {
  return findColour(product, name)?.hex || "#cbd5e1";
}
